import { routes } from '@/shared/routes';
import { SmartTaskType } from '@/shared/types/enum';
import { formatEnum, formatWeekdayMonthYear } from '@/shared/utils/format';

import { getControl, getFormData } from '@/front/editable/state';
import { listen } from '@/front/event';
import { POST } from '@/front/fetch';

const selectors = (...fields: string[]) =>
  fields.map((field) => `.editable[data-model="RecurringTask"][data-field="${field}"]`).join(', ');

const separator = '<i class="fa-solid fa-arrow-right me-3"></i>';

listen('editablesReady', () => {
  [
    ...document.querySelectorAll(
      selectors(
        'scheduleInterval',
        'scheduleFrequency',
        'scheduleDay',
        'startFromDate',
        'continueUntilDate',
        'startDateOffset_interval',
        'startDateOffset_type',
        'startDateOffset_direction',
        'completionDateOffset_interval',
        'completionDateOffset_type',
        'completionDateOffset_direction',
        'deadlineDateOffset_interval',
        'deadlineDateOffset_type',
        'deadlineDateOffset_direction',
        'smartTaskType',
      ),
    ),
  ]
    .map((editableElement) => editableElement as HTMLDivElement)
    .forEach((editableElement) => {
      const control = getControl(editableElement.id);

      if (control) {
        const form = editableElement.closest('form') as HTMLFormElement;

        control.addEventListener('change', async () => {
          await preview(form);
        });
      }
    });

  [
    ...document.querySelectorAll(
      selectors(
        'scheduleFrequency',

        'smartTaskType',
      ),
    ),
  ]
    .map((editableElement) => editableElement as HTMLDivElement)
    .forEach((editableElement) => {
      const form = editableElement.closest('form') as HTMLFormElement;

      preview(form);
    });
});

const preview = async (form: HTMLFormElement) => {
  const data = getFormData(form);

  if (data.smartTaskType || (data.scheduleInterval && data.scheduleFrequency && data.startFromDate)) {
    const route = data.smartTaskType ? routes.smartTasks.preview() : routes.recurringTasks.preview();

    const res = await POST(route, data);

    if (res.ok) {
      const { dueDate, startDate, completionDate, deadlineDate } = await res.json();

      const dueDatePreviewSpan = form.querySelector('span[data-role="dueDatePreview') as HTMLSpanElement;

      const startDatePreviewSpan = form.querySelector('span[data-role="startDatePreview') as HTMLSpanElement;
      const completionDatePreviewSpan = form.querySelector('span[data-role="completionDatePreview') as HTMLSpanElement;
      const deadlineDatePreviewSpan = form.querySelector('span[data-role="deadlineDatePreview') as HTMLSpanElement;

      dueDatePreviewSpan.innerHTML = dueDate
        ? `Example ${
            data.smartTaskType ? formatEnum(SmartTaskType, data.smartTaskType as string) : 'due'
          } date: ${formatWeekdayMonthYear(dueDate)}`
        : '';

      startDatePreviewSpan.innerHTML = startDate ? separator + formatWeekdayMonthYear(startDate) : '';
      completionDatePreviewSpan.innerHTML = completionDate ? separator + formatWeekdayMonthYear(completionDate) : '';
      deadlineDatePreviewSpan.innerHTML = deadlineDate ? separator + formatWeekdayMonthYear(deadlineDate) : '';
    }
  }
};
